module.exports = __webpack_public_path__ + "img/17-green.53ecdc74.svg";